<template>
    <div id="page">
    <div id="outer">
      <div id="title-div">
        <div id="allSpan-div">
          <div id="span-div1">
            <span id="title-span">
              学科评估
            </span>
          </div>
        </div>

        <div id="select-banner" style="margin-right: 122px;">
              <el-form :model="form" inline style="display: flex;align-items: center;" label-width="80px">
                <el-form-item label="院校名称" style="display: flex;">
                  <el-input placeholder="请输入院校名称" v-model="form.collegeName" @keyup.enter.native="xuekeList()" clearable=""></el-input>
                </el-form-item>
                <el-form-item label="专业名称" style="display: flex;">
                  <el-input placeholder="请输入专业名称" v-model="form.specialty_title" @keyup.enter.native="xuekeList()" clearable=""></el-input>
                </el-form-item>
                <el-form-item style="display: flex;">
                  <el-button type="success" size="small" @click="xuekeList()">查询</el-button>
                </el-form-item>
              </el-form>
        </div>

      </div>

      <div style="width:80%;height: 78%;overflow-y: auto;margin: 0 auto;" v-loading="loading">
         <div v-for="(item,i) in list" :key="i">
             <h4>{{item.collegeName}}</h4>
             <el-table :data="returnResult(item.result)" v-if="item.result" border style="width: 100%" :header-cell-style="{background:'#f5f5f5'}">
              <el-table-column prop="title" label="评定结果" width="120" align="center">
              </el-table-column>
              <el-table-column prop="content" label="专业" align="center">
              </el-table-column>
        </el-table>
         </div>
      </div>

    </div>
    </div>
</template>

<script>
  import { xuekeList } from "@/api/gw/zonghe.js"
  export default{
    data(){
      return{
        loading:false,
        form:{
          collegeName:"",
          specialty_title:""
        },
        list:[],
      }
    },
    mounted(){
       this.xuekeList();
    },
    methods:{
      xuekeList(){
        this.loading = true
        xuekeList(this.form).then(res=>{
          this.list = res.data
        }).finally(()=>{
          this.loading = false
        })
      },
      returnResult(obj){
        var arr = Object.keys(obj).map(key => ({
          title: key,
          content: obj[key].content
        }));
        arr = arr.filter(r=>{
          return r.title;
        })
        return arr;
      },
    }
  }
</script>

<style lang="scss" scoped>
@import '../scss/index.scss';

::v-deep .el-table {
  overflow: visible !important;
}

::v-deep .el-table__header-wrapper {
  position: sticky !important;
  top: 0 !important; //这个值根据实际情况而定
  z-index: 10 !important;
}
</style>




// WEBPACK FOOTER //
// src/views/comprehensive/components/pinggu.vue